<script lang="ts">
    export let visible = false;
    export let titleText;
    export let reasonText;
    export let onClose = () => {};

    function close() {
        visible = false;
        onClose();
    }
</script>

<div
    class="modal-container"
    class:visible
    class:compact={reasonText === ""}
    on:click={close}
>
    <div class="modal" on:click={(e) => e.stopPropagation()}>
        <div class="close-btn" on:click={close} />
        <p class="title">{titleText}</p>
        <p class="subtitle">{reasonText}</p>
        <slot name="content" />
    </div>
</div>

<style>
    .modal-container {
        width: 100vw;
        height: 100vh;
        z-index: 1;
        position: absolute;
        pointer-events: none;
        opacity: 0;
        transition: all 0.5s ease;
        background-color: rgba(0, 0, 0, 0.25);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    @supports (backdrop-filter: blur(6px)) {
        .modal-container {
            background-color: rgba(0, 0, 0, 0.05);
            backdrop-filter: blur(6px);
        }
    }

    .modal-container.visible {
        opacity: 1;
        pointer-events: all;
    }
    .modal {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        background-color: aliceblue;
        border-radius: 1.5rem;
        padding: 0.8rem 1.7rem 1.5rem 1.7rem;
        overflow: hidden;
        border: 2px solid rgba(0, 0, 0, 0.05);
    }
    .title {
        font-weight: 700;
        font-size: 3.3rem;
    }
    .subtitle {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 1.5rem;
    }
    .modal-container.compact .subtitle {
        display: none;
    }
    .subtitle::after {
        content: "";
        display: inline-block;
        width: 140%;
        margin: 0.3rem -2rem 0 -2rem;

        border-bottom: 3px solid rgba(0, 0, 0, 0.05);
    }
    .close-btn {
        top: 1rem;
        right: 1rem;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        opacity: 0.6;
        transition: all 0.1s ease;
        cursor: pointer;
    }
    .close-btn:hover {
        opacity: 0.8;
        transform: scale(1.1);
    }
    .close-btn::before,
    .close-btn::after {
        position: absolute;
        content: "";
        display: inline-block;
        width: 0.8rem;
        height: 0.1rem;
        background-color: black;
    }
    .close-btn::before {
        transform: rotate(-45deg);
    }
    .close-btn::after {
        transform: rotate(45deg);
    }
</style>
